import axios from "axios"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { getId, getToken, usePermissions } from "../../user/User"
import BasicTableComponent, { NumberRangeColumnFilter } from "../../components/basic.table"
import { toast } from "react-toastify"

const TagList = () => {
    const navigate = useNavigate()

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.tag !== undefined && !permissions.tag) {
            toast.error("You don't have permission to view tags!")
            navigate("/")
        }
    }, [permissions])

    const handleCreate = async e => {
        e.preventDefault(),
        navigate("/tag/create")
    }

    const columns =  [{
        Header: "Edit",
        UrlPart: "tag"
    }, {
        Header: "Delete",
        UrlPart: "tag/delete"
    }, {
        Header: "Id",
        accessor: "id",
        Filter: NumberRangeColumnFilter,
        filter: 'between'
    }, {
        Header: "Name",
        accessor: "name"
    }]

    const [tags, setTags] = useState([])

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + "/api/tags", {
            headers: {
                "Authorization": "Bearer " + getToken()
            }
        })
        .then(res => {
            if(res.data === null || res.data === "" || !Array.isArray(res.data)) {
                return
            }
            setTags(res.data)
        }).catch(_ => {
            toast.error("Unable to load tags!")
        })
    }, [])

    return (
        <div>
            <button className="btn btn-primary" onClick={handleCreate}>Create tag</button>
            <br /><br />

            <BasicTableComponent columns={columns} data={tags} />
        </div>
    )
}

export default TagList
